export enum FormType {
    Donation = 0,
    Lead = 1,
    Pledge = 2,
}